import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Chip, Stack, Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
} from "@mui/material";

const label = (s) => String(s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

// Reusable "students who can apply" table (name / email / course + applied status).
export default function EligibleTable({ rows = [], loading = false }) {
  const navigate = useNavigate();

  const appliedCount = rows.filter(
    (s) => s.application_status && s.application_status !== "not_interested"
  ).length;
  const notRespondedCount = rows.filter((s) => !s.application_status).length;

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ mb: 2, flexWrap: "wrap", gap: 1 }}>
        <Chip color="primary" label={`${rows.length} eligible`} />
        <Chip color="success" variant="outlined" label={`${appliedCount} applied`} />
        <Chip color="warning" variant="outlined" label={`${notRespondedCount} not responded`} />
      </Stack>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Course</TableCell>
              <TableCell>Batch</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Response</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 5, color: "text.secondary" }}>
                  {loading ? "Loading…" : "No eligible students found for this job's batch."}
                </TableCell>
              </TableRow>
            )}
            {rows.map((s, i) => {
              const responded = Boolean(s.application_status);
              const isNotInterested = s.application_status === "not_interested";
              return (
                <TableRow key={s.admn_no} hover>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>
                    <Typography variant="body2" fontWeight={600}>{s.student_name}</Typography>
                    <Typography variant="caption" color="text.secondary">Admn {s.admn_no}</Typography>
                  </TableCell>
                  <TableCell>{s.email || ""}</TableCell>
                  <TableCell>{s.course_name || ""}</TableCell>
                  <TableCell>{s.course_batch_name || ""}</TableCell>
                  <TableCell>{s.student_mob_no || ""}</TableCell>
                  <TableCell>
                    {responded ? (
                      <Chip
                        size="small"
                        color={isNotInterested ? "default" : "success"}
                        variant={isNotInterested ? "outlined" : "filled"}
                        label={isNotInterested ? "Not interested" : `Applied · ${label(s.application_status)}`}
                        onClick={
                          s.career_application_id && !isNotInterested
                            ? () => navigate(`/career-connect/applications/${s.career_application_id}`)
                            : undefined
                        }
                        clickable={Boolean(s.career_application_id && !isNotInterested)}
                      />
                    ) : (
                      <Chip size="small" variant="outlined" label="Not applied" />
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
